import React from "react";

const IFilter = ({
  color = "#252526",
  width = "10",
  height = "10",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      {...props}
    >
      <path
        d="M6.24994 7.75C6.24994 7.94672 6.15731 8.13197 5.99994 8.25L4.10003 9.6748C3.98646 9.75998 3.83446 9.77386 3.70745 9.71045C3.58041 9.64693 3.49994 9.51704 3.49994 9.375V5.00342L0.079037 0.605469C-0.00885276 0.492468 -0.0247996 0.339073 0.0380213 0.210449C0.100947 0.0817879 0.23171 0 0.374935 0H9.37494C9.51816 0 9.64892 0.0817879 9.71185 0.210449C9.77467 0.339073 9.75872 0.492468 9.67083 0.605469L6.24994 5.00342V7.75ZM4.24994 8.625L5.49994 7.68701V4.96094C5.49994 4.82195 5.54644 4.68686 5.63177 4.57715L8.60833 0.75H1.14154L4.1181 4.57715C4.20343 4.68686 4.24994 4.82195 4.24994 4.96094V8.625Z"
        fill={color}
      />
      <path
        d="M0.374935 0.375H9.37494L5.9276 4.80729C5.89347 4.85118 5.87494 4.90518 5.87494 4.96078V7.75C5.87494 7.82869 5.83789 7.90279 5.77494 7.95L3.87494 9.375V4.96078C3.87494 4.90518 3.8564 4.85118 3.82227 4.80729L0.374935 0.375Z"
        fill={color}
      />
    </svg>
  );
};

export default IFilter;
